

export default umd;
import transformExportDeclaration from './utils/transformExportDeclaration';
import packageResult from 'utils/packageResult';
import umdIntro from 'utils/umd/umdIntro';
import requireName from 'utils/umd/requireName';
function umd(mod, options) {
	requireName(options);

	mod.imports.forEach(function (x) {
		mod.body.remove(x.start, x.next);
	});

	var intro = umdIntro({
		hasExports: mod.exports.length > 0,
		imports: mod.imports,
		amdName: options.amdName,
		absolutePaths: options.absolutePaths,
		name: options.name,
		indentStr: mod.body.getIndentString(),
		useStrict: options.useStrict !== false
	});

	transformExportDeclaration(mod.exports[0], mod.body);

	mod.body.indent().prepend(intro).trimLines().append('\n\n}));');

	return packageResult(mod, mod.body, options, 'toUmd');
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/defaultsMode/umd.js.01-babel.map